import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
// import PurchaseModal from './PurchaseModal'; // No longer needed since we are hiding the Buy Now button
//okkk

interface HeaderProps {
  onNavigate?: (view: 'home' | 'products' | 'product-selection' | 'product-detail' | 'applications' | 'gallery' | 'faq' | 'contact' ) => void;
}

const Header: React.FC<HeaderProps> = ({ onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false); // Remove related state

  const navigationItems = [
    { label: 'Home', href: '#home', action: () => onNavigate?.('home') },
    { label: 'Products', href: '#products', action: () => onNavigate?.('product-selection') },
    { label: 'Applications', href: '#applications', action: () => onNavigate?.('applications') },
    { label: 'Gallery', href: '#gallery', action: () => onNavigate?.('gallery') },
    { label: 'FAQ', href: '#faq', action: () => onNavigate?.('faq') },
    { label: 'Contact', href: '#contact', action: () => onNavigate?.('contact') },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <button
                onClick={() => onNavigate?.('home')}
                className="text-2xl font-bold text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
              >
                Flexcrete
              </button>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {navigationItems.map((item) => (
                <button
                  key={item.label}
                  onClick={item.action}
                  className="text-gray-700 hover:text-primary-600 px-3 py-2 text-sm font-medium transition-colors duration-200"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </nav>

          {/* 
            CTA Button Hidden As Per Instruction 
            <div className="hidden md:block ml-8">
              <button 
                onClick={() => setIsPurchaseModalOpen(true)}
                className="btn-primary"
              >
                Buy Now
              </button>
            </div>
          */}

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 hover:text-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 p-2"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden border-t border-gray-200"
            >
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigationItems.map((item) => (
                  <button
                    key={item.label}
                    onClick={() => {
                      item.action();
                      setIsMenuOpen(false);
                    }}
                    className="text-gray-700 hover:text-primary-600 block px-3 py-2 text-base font-medium transition-colors duration-200 w-full text-left"
                  >
                    {item.label}
                  </button>
                ))}
                {/* Buy Now button hidden in mobile menu as well */}
                {/* 
                <div className="pt-4">
                  <button 
                    onClick={() => {
                      setIsPurchaseModalOpen(true);
                      setIsMenuOpen(false);
                    }}
                    className="btn-primary w-full"
                  >
                    Buy Now
                  </button>
                </div>
                */}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Purchase Modal Hidden */}
      {/* 
      <PurchaseModal 
        isOpen={isPurchaseModalOpen} 
        onClose={() => setIsPurchaseModalOpen(false)} 
      />
      */}
    </header>
  );
};

export default Header;
